import { appConfig } from '../../config/appConfig';
import { beginExperience } from '../../state/appState';

// Intro screen — INTRO state.
// Renders the branded entry point with maritime theme, logo placeholder,
// tagline, and Begin Experience CTA.

export function renderIntroScreen(root: HTMLElement): void {
  root.innerHTML = `
    <div class="intro-screen">
      <!-- Top-left museum logo area -->
      <div class="intro-logo" aria-label="Sag Harbor Whaling and Historical Museum">
        <img src="/assets/logo.png" alt="Museum Logo" />
        <!--
        <div class="intro-logo__mark"></div>
        <span class="intro-logo__text">Sag Harbor<br>Whaling &amp; Historical Museum</span>
        -->
      </div>

      <!-- Center content -->
      <div class="intro-content">
        <div class="intro-whale-icon" aria-hidden="true">
          <img src="/assets/whale_icon.png" alt="Whale Icon" aria-hidden="true" />
        </div>
        <p class="intro-tagline">${appConfig.copy.introTagline}</p>
      </div>

      <!-- Bottom CTA -->
      <div class="intro-footer">
        <button
          class="intro-cta"
          id="begin-experience-btn"
          type="button"
          aria-label="${appConfig.copy.beginCta}"
        >
          ${appConfig.copy.beginCta}
        </button>
      </div>
    </div>
  `;

  // Wire the CTA. Disable the button immediately on first tap so that rapid
  // repeat taps cannot trigger duplicate transitions — the button becomes
  // inert before the state change fires any re-render.
  const btn = root.querySelector<HTMLButtonElement>('#begin-experience-btn');
  if (btn) {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      beginExperience();
    }, { once: true });
  }
}
